<!--
1. Make sure update works (esp. for all fields.)
2. Do we want to show profile completion % on sign up?
-->
<section forms class="py-5 px-7 sm:py-16 sm:px-20 mx-auto max-w-4xl">
  <div class="flex flex-col gap-3">
    <mat-card class="w-min" *ngIf="callerService.corpMember.Media?.url">
      <img
        mat-card-image
        [src]="callerService.corpMember.Media?.url"
        alt="Your profile picture"
        class="object-cover max-w-14 h-auto"
      />
    </mat-card>
    <h5 class="text-2xl font-semibold">
      <ng-container *ngIf="callerService.corpMember.first_name">
        <a [routerLink]="['/p', callerService.corpMember.slug_id ?? callerService.corpMember.created_at]">{{ callerService.corpMember.first_name }}</a>
        &middot;
      </ng-container>
      {{ callerService.corpMember.state_code }}
    </h5>
  </div>

  <mat-card class="mt-5" *ngIf="callerService.corpMember.slug_id">
    <mat-card-header>
      <mat-card-subtitle>Invite others!</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>{{INVITE_TEXT}}</mat-card-content>
      <mat-card-actions align="end">
        <button type="button" mat-button color="primary" (click)="copyInviteText()">Copy message</button>
      </mat-card-actions>
  </mat-card>


  <mat-divider class="!mt-9 !mb-3"></mat-divider>
  <h2 class="text-2xl pb-6">Service Details</h2>
  <form
    class="grid grid-cols-1 md:grid-cols-2 gap-5"
    [formGroup]="serviceDetailsFormGroup"
  >
    <mat-form-field class="example-" appearance="fill">
      <mat-label>Serving state</mat-label>

      <mat-select formControlName="service_state">
        <mat-option
          *ngFor="let option of ng_states"
          [value]="option.name"
          (onSelectionChange)="setSelectedStatesLGA($event, option)"
        >
          {{ option.name }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="
          serviceDetailsFormGroup?.get(['service_state'])?.hasError('required')
        "
      >
        Serving state is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>LGA</mat-label>

      <mat-select formControlName="lga_id">
        <mat-option
          *ngFor="let option of selected_state_lgas"
          [value]="option.id"
        >
          {{ option.name }}
        </mat-option>
      </mat-select>
      <mat-hint>Required</mat-hint>
      <mat-error
        *ngIf="serviceDetailsFormGroup?.get(['lga'])?.hasError('required')"
      >
        LGA is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>City or Town</mat-label>
      <input title="City or Town" matInput formControlName="city_or_town" />
      <mat-error
        *ngIf="
          serviceDetailsFormGroup?.get(['city_or_town'])?.hasError('required')
        "
      >
        City or Town is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Stream</mat-label>
      <mat-select formControlName="stream">
        <mat-option *ngFor="let stream of serviceStreams" [value]="stream">
          {{ stream }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="serviceDetailsFormGroup?.get(['stream'])?.hasError('required')"
      >
        Stream is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>State code</mat-label>
      <input
        title="State code"
        matInput
        formControlName="state_code"
        [disabled]="stateCodeInputDisabled"
      />
      <!--
              TODO: once you want to edit your state code, we'll ask you if you're sure!
              It'll show you a modal with a confirmation message. The default state of the state code input is disabled.
              Until then, leave this edit button commented.
            -->
      <!-- <button
                type="button"
                *ngIf="serviceDetailsFormGroup?.get(['state_code'])?.value"
                matSuffix
                mat-icon-button
                aria-label="Edit state code"
                (click)="toggleStateCodeInputDisabled()"
            >
                <mat-icon>edit</mat-icon>
            </button> -->
      <mat-error
        *ngIf="
          serviceDetailsFormGroup?.get(['state_code'])?.hasError('required')
        "
      >
        State code is <strong>required</strong>
      </mat-error>
      <mat-error
        *ngIf="
          serviceDetailsFormGroup?.get(['state_code'])?.hasError('pattern') &&
          !serviceDetailsFormGroup?.get(['state_code'])?.hasError('required')
        "
      >
        Please enter a valid state code
      </mat-error>
    </mat-form-field>
  </form>

  <mat-divider class="!mt-9 !mb-3"></mat-divider>

  <h2 class="text-2xl pb-6">Personal Details</h2>
  <form
    class="grid grid-cols-1 md:grid-cols-2 gap-5"
    [formGroup]="personalDetailsFormGroup"
  >
    <mat-form-field class="example-" appearance="fill">
      <mat-label>First name</mat-label>
      <input formControlName="first_name" matInput placeholder="Remi" />
      <mat-error
        *ngIf="
          personalDetailsFormGroup?.get(['first_name'])?.hasError('required')
        "
      >
        First name is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Last name</mat-label>
      <input formControlName="last_name" matInput placeholder="Ikenna" />
      <mat-error
        *ngIf="
          personalDetailsFormGroup?.get(['last_name'])?.hasError('required')
        "
      >
        Last name is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Do you have a nickname you go by?</mat-label>
      <input
        title="Nickname"
        matInput
        formControlName="nickname"
        placeholder="Obong"
      />
      <mat-hint
        >A nickname other corp members around you might know you by, or you'd
        want them to know you by.</mat-hint
      >
    </mat-form-field>
  </form>

  <mat-divider class="!mt-9 !mb-3"></mat-divider>

  <h2 class="text-2xl pb-6">PPA Details</h2>
  <form
    class="grid grid-cols-1 md:grid-cols-2 gap-5"
    [formGroup]="ppaDetailsFormGroup"
  >
    <mat-form-field>
      <mat-label>Name of PPA</mat-label>
      <input
        formControlName="ppa_name"
        matInput
        placeholder="St. Mary's Model Secondary School"
        [matAutocomplete]="autoPpaNames"
      />
      <button
        type="button"
        *ngIf="ppaDetailsFormGroup?.get(['ppa_name'])?.value"
        matSuffix
        mat-icon-button
        aria-label="Clear PPA name"
        (click)="ppaDetailsFormGroup.get('ppa_name')?.setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-autocomplete
        #autoPpaNames="matAutocomplete"
        [displayWith]="displayPpaName"
        (optionSelected)="ppaSelected($event)"
      >
        <mat-option
          *ngFor="let option of filteredLgaPPAs | async"
          [id]="option.id"
          [value]="option.name"
        >
          {{ option?.name }}
        </mat-option>
      </mat-autocomplete>
      <mat-hint>This helps other corp members find it</mat-hint>
      <!-- dropdown of suggestions from other corp members from the backend. -->

      <mat-error
        *ngIf="ppaDetailsFormGroup.get(['ppa_name'])?.hasError('required')"
      >
        Name is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Type of Institution</mat-label>
      <!-- TODO: should be like a dropdown or have suggestions list -->
      <mat-hint>eg. School, Bank, Hospital, Gov. Institution, etc.</mat-hint>
      <input
        title="Type of Institution"
        formControlName="type_of_institution"
        matInput
        [matAutocomplete]="autoTypeOfInstitution"
      />
      <button
        type="button"
        *ngIf="ppaDetailsFormGroup?.get(['type_of_institution'])?.value"
        matSuffix
        mat-icon-button
        aria-label="Clear PPA Type"
        (click)="ppaDetailsFormGroup.get('type_of_institution')?.setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-autocomplete
        autoActiveFirstOption
        #autoTypeOfInstitution="matAutocomplete"
      >
        <mat-option
          *ngFor="let option of filteredTypeOfInstitutionOptions | async"
          [value]="option"
        >
          {{ option }}
        </mat-option>
        <!-- LATER: this other specify kinda works right now... can the UX be improved? -->
        <mat-option value=""> Others (Specify) </mat-option>
      </mat-autocomplete>
      <mat-error
        *ngIf="
          ppaDetailsFormGroup.get(['type_of_institution'])?.hasError('required')
        "
      >
        PPA Type is <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="h-fit">
      <mat-label>PPA address</mat-label>
      <!-- we should save the coordinates too if they used geo button -->
      <input
        formControlName="ppa_address"
        matInput
        placeholder="Opposite Ijukaya Estate, Favos, Umuahia"
      />
      <mat-hint>
        Address in
        <span>{{ serviceDetailsFormGroup.get(['service_state'])?.value }}</span>
        <span *ngIf="serviceDetailsFormGroup.get(['lga_id'])?.value"
          >, {{ corpMemberSelectedLgaName }}
        </span>
      </mat-hint>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Directions</mat-label>
      <textarea
        formControlName="ppa_directions"
        matInput
        placeholder="Please give directions to the PPA from a popular nearby junction or hard-to-miss building"
      ></textarea>
      <mat-hint>From a popular landmark</mat-hint>
    </mat-form-field>
  </form>

  <mat-divider class="!mt-9 !mb-3"></mat-divider>

  <h2 class="text-2xl pb-6">Other Details</h2>
  <form
    class="grid grid-cols-1 md:grid-cols-2 gap-5"
    [formGroup]="otherDetailsFormGroup"
  >
    <mat-form-field>
      <mat-label>Origin state</mat-label>
      <mat-select formControlName="travel_from_state">
        <mat-option *ngFor="let option of ng_states" [value]="option.name">
          {{ option.name }}
        </mat-option>
      </mat-select>
      <mat-hint>Optional. Where did you travel from for NYSC?</mat-hint>
      <mat-hint align="end" class="cursor-help">
        <mat-icon
          matTooltipPosition="above"
          matTooltip="So we can help pair corp members traveling together, or assist with transportation from our patners (ABC Transport, Jos Riders, etc.)"
          >info</mat-icon
        >
      </mat-hint>
      <!-- TODO: pull a dropdown of suggestions from other corp members from the backend. -->
    </mat-form-field>

    <mat-form-field>
      <mat-label>Origin city or town</mat-label>
      <mat-hint>Optional</mat-hint>
      <input
        title="Origin city or town"
        matInput
        formControlName="travel_from_city"
      />
    </mat-form-field>

    <!-- We don't really need to ask this question -->
    <!-- <mat-form-field class="h-fit">
            <mat-label>Where did you find accommodation?</mat-label>
            <input
                formControlName="where_they_found_accommodation"
                matInput
                placeholder="What part of town is it?"
            />
            <mat-hint
                >So corp members can know where other corp members
                are.</mat-hint
            >
        </mat-form-field> -->

    <div class="custom-radio-form-field">
      <!-- TODO: If they choose yes, we'll ask them what kind. -->
      <label>Want an SPA?</label>
      <mat-radio-group
        aria-label="Select an option"
        class="radio-group"
        formControlName="want_spa_or_not"
      >
        <mat-radio-button [value]="true">Yes</mat-radio-button>
        <mat-radio-button [value]="false">No</mat-radio-button>
      </mat-radio-group>
      <mat-hint class="mat-caption text-xs"
        >An SPA is a side job you do, if you have the time, during your Service
        Year for extra cash</mat-hint
      >
    </div>

    <!-- Too important a section to be in other details? -->
    <div class="custom-radio-form-field">
      <label>Looking for a roommate?</label>
      <mat-radio-group
        aria-label="Select an option"
        class="radio-group"
        formControlName="looking_for_accommodation_or_not"
      >
        <mat-radio-button [value]="true">Yes</mat-radio-button>
        <mat-radio-button [value]="false">No</mat-radio-button>
      </mat-radio-group>
    </div>
  </form>

  <mat-divider class="!mt-9 !mb-3"></mat-divider>

  <h2 class="text-2xl pb-6">Bio</h2>
  <form
    class="grid grid-cols-1 md:grid-cols-2 gap-5"
    [formGroup]="bioDetailsFormGroup"
  >
    <div class="custom-radio-form-field">
      <label>Public profile?</label>
      <!-- https://stackoverflow.com/a/57634824/9259701 -->
      <mat-radio-group
        aria-label="Select an option"
        class="radio-group"
        formControlName="public_profile"
      >
        <mat-radio-button [value]="true">Publicly visible</mat-radio-button>
        <mat-radio-button [value]="false">Keep private</mat-radio-button>
      </mat-radio-group>
      <mat-hint class="mat-caption text-xs"
        >A publicly visible profile means you can
        <b>search for other corp members</b> and <b>be seen by them too</b>.
      </mat-hint>
    </div>

    <mat-form-field>
      <mat-label>Profile</mat-label>
      <!-- TODO: should we change the label from profile? to something better descriptive? -->
      <textarea
        matInput
        #profile
        maxlength="500"
        formControlName="bio"
        rows="5"
        placeholder="I'm a graphic designer. Get in touch if you like to travel. I'm your plug for all things phones. I'd love to visit Idanre hills before service year is over, who's in?"
      ></textarea>
      <mat-hint
        >What do you want other corp members to know about you?</mat-hint
      >
      <mat-hint align="end">{{ profile.value.length }} / 500</mat-hint>
    </mat-form-field>

    <div class="flex flex-col gap-2">
      <label for="profile_photo">Profile photo:</label>

      <mat-card
        class="w-min"
        *ngIf="selectedImage || callerService.corpMember.Media?.url"
      >
        <img
          mat-card-image
          [src]="selectedImage || callerService.corpMember.Media?.url"
          alt="Your chosen profile picture"
          class="object-cover max-w-72 h-auto"
        />
      </mat-card>

      <!--
          File input design from https://tailwindcss.com/docs/hover-focus-and-other-states#file-input-buttons
          TODO: make it more like our feel.
      -->
      <input
        #profilePhotoInput
        title="Upload profile photo"
        accept="image/*"
        name="profile_photo"
        type="file"
        class="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-violet-50 file:text-violet-700 hover:file:bg-violet-100 cursor-pointer"
        (change)="onFileSelected($event)"
      />
    </div>
  </form>

  <mat-divider class="!mt-9 !mb-3"></mat-divider>

  <!-- prev. (click)="updateCorpMemberProfile()" after that updateEverything() -->
  <app-progress-button
    buttonClass="width-fit"
    (click)="updateProfile()"
    buttonText="Update details"
    [loading]="isUpdatingProfile"
    [disabled]="isUpdatingProfile"
  ></app-progress-button>
</section>
